module.exports = __webpack_public_path__ + "img/btn.eeb22ec5.jpg";